import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { invariant } from '../../utils/errors.mjs';
import { PanSession } from '../pan/PanSession.mjs';
import { getGlobalLock } from './utils/lock.mjs';
import { isRefObject } from '../../utils/is-ref-object.mjs';
import { addPointerEvent } from '../../events/add-pointer-event.mjs';
import { applyConstraints, calcRelativeConstraints, resolveDragElastic, rebaseAxisConstraints, calcViewportConstraints, calcOrigin, defaultElastic } from './utils/constraints.mjs';
import { createBox } from '../../projection/geometry/models.mjs';
import { eachAxis } from '../../projection/utils/each-axis.mjs';
import { measurePageBox } from '../../projection/utils/measure.mjs';
import { extractEventInfo } from '../../events/event-info.mjs';
import { convertBoxToBoundingBox, convertBoundingBoxToBox } from '../../projection/geometry/conversion.mjs';
import { addDomEvent } from '../../events/add-dom-event.mjs';
import { calcLength } from '../../projection/geometry/delta-calc.mjs';
import { mixNumber } from '../../utils/mix/number.mjs';
import { percent } from '../../value/types/numbers/units.mjs';
import { animateMotionValue } from '../../animation/interfaces/motion-value.mjs';
import { getContextWindow } from '../../utils/get-context-window.mjs';
import { addValueToWillChange } from '../../value/use-will-change/add-will-change.mjs';
import { frame } from '../../frameloop/frame.mjs';
var elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
var VisualElementDragControls = /*#__PURE__*/function () {
  function VisualElementDragControls(visualElement) {
    _classCallCheck(this, VisualElementDragControls);
    // This is a reference to the global drag gesture lock, ensuring only one component
    // can "capture" the drag of one or both axes.
    // TODO: Look into moving this into pansession?
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = {
      x: 0,
      y: 0
    };
    /**
     * The permitted boundaries of travel, in pixels.
     */
    this.constraints = false;
    this.hasMutatedConstraints = false;
    /**
     * The per-axis resolved elastic values.
     */
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  return _createClass(VisualElementDragControls, [{
    key: "start",
    value: function start(originEvent) {
      var _this = this;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$snapToCursor = _ref.snapToCursor,
        snapToCursor = _ref$snapToCursor === void 0 ? false : _ref$snapToCursor;
      /**
       * Don't start dragging if this component is exiting
       */
      var presenceContext = this.visualElement.presenceContext;
      if (presenceContext && presenceContext.isPresent === false) return;
      var onSessionStart = function onSessionStart(event) {
        var _this$getProps = _this.getProps(),
          dragSnapToOrigin = _this$getProps.dragSnapToOrigin;
        // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
        // the component.
        dragSnapToOrigin ? _this.pauseAnimation() : _this.stopAnimation();
        if (snapToCursor) {
          _this.snapToCursor(extractEventInfo(event, "page").point);
        }
      };
      var onStart = function onStart(event, info) {
        var _a;
        // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
        var _this$getProps2 = _this.getProps(),
          drag = _this$getProps2.drag,
          dragPropagation = _this$getProps2.dragPropagation,
          onDragStart = _this$getProps2.onDragStart;
        if (drag && !dragPropagation) {
          if (_this.openGlobalLock) _this.openGlobalLock();
          _this.openGlobalLock = getGlobalLock(drag);
          // If we don 't have the lock, don't start dragging
          if (!_this.openGlobalLock) return;
        }
        _this.isDragging = true;
        _this.currentDirection = null;
        _this.resolveConstraints();
        if (_this.visualElement.projection) {
          _this.visualElement.projection.isAnimationBlocked = true;
          _this.visualElement.projection.target = undefined;
        }
        /**
         * Record gesture origin
         */
        eachAxis(function (axis) {
          var current = _this.getAxisMotionValue(axis).get() || 0;
          /**
           * If the MotionValue is a percentage value convert to px
           */
          if (percent.test(current)) {
            var projection = _this.visualElement.projection;
            if (projection && projection.layout) {
              var measuredAxis = projection.layout.layoutBox[axis];
              if (measuredAxis) {
                var length = calcLength(measuredAxis);
                current = length * (parseFloat(current) / 100);
              }
            }
          }
          _this.originPoint[axis] = current;
        });
        // Fire onDragStart event
        if (onDragStart) {
          frame.postRender(function () {
            return onDragStart(event, info);
          });
        }
        (_a = _this.removeWillChange) === null || _a === void 0 ? void 0 : _a.call(_this);
        _this.removeWillChange = addValueToWillChange(_this.visualElement, "transform");
        var animationState = _this.visualElement.animationState;
        animationState && animationState.setActive("whileDrag", true);
      };
      var onMove = function onMove(event, info) {
        // latestPointerEvent = event
        var _this$getProps3 = _this.getProps(),
          dragPropagation = _this$getProps3.dragPropagation,
          dragDirectionLock = _this$getProps3.dragDirectionLock,
          onDirectionLock = _this$getProps3.onDirectionLock,
          onDrag = _this$getProps3.onDrag;
        // If we didn't successfully receive the gesture lock, early return.
        if (!dragPropagation && !_this.openGlobalLock) return;
        var offset = info.offset;
        // Attempt to detect drag direction if directionLock is true
        if (dragDirectionLock && _this.currentDirection === null) {
          _this.currentDirection = getCurrentDirection(offset);
          // If we've successfully set a direction, notify listener
          if (_this.currentDirection !== null) {
            onDirectionLock && onDirectionLock(_this.currentDirection);
          }
          return;
        }
        // Update each point with the latest position
        _this.updateAxis("x", info.point, offset);
        _this.updateAxis("y", info.point, offset);
        /**
         * Ideally we would leave the renderer to fire naturally at the end of
         * this frame but if the element is about to change layout as the result
         * of a re-render we want to ensure the browser can read the latest
         * bounding box to ensure the pointer and element don't fall out of sync.
         */
        _this.visualElement.render();
        /**
         * This must fire after the render call as it might trigger a state
         * change which itself might trigger a layout update.
         */
        onDrag && onDrag(event, info);
      };
      var onSessionEnd = function onSessionEnd(event, info) {
        return _this.stop(event, info);
      };
      var resumeAnimation = function resumeAnimation() {
        return eachAxis(function (axis) {
          var _a;
          return _this.getAnimationState(axis) === "paused" && ((_a = _this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
        });
      };
      var _this$getProps4 = this.getProps(),
        dragSnapToOrigin = _this$getProps4.dragSnapToOrigin;
      this.panSession = new PanSession(originEvent, {
        onSessionStart: onSessionStart,
        onStart: onStart,
        onMove: onMove,
        onSessionEnd: onSessionEnd,
        resumeAnimation: resumeAnimation
      }, {
        transformPagePoint: this.visualElement.getTransformPagePoint(),
        dragSnapToOrigin: dragSnapToOrigin,
        contextWindow: getContextWindow(this.visualElement)
      });
    }
  }, {
    key: "stop",
    value: function stop(event, info) {
      var _a;
      (_a = this.removeWillChange) === null || _a === void 0 ? void 0 : _a.call(this);
      var isDragging = this.isDragging;
      this.cancel();
      if (!isDragging) return;
      var velocity = info.velocity;
      this.startAnimation(velocity);
      var _this$getProps5 = this.getProps(),
        onDragEnd = _this$getProps5.onDragEnd;
      if (onDragEnd) {
        frame.postRender(function () {
          return onDragEnd(event, info);
        });
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.isDragging = false;
      var _this$visualElement = this.visualElement,
        projection = _this$visualElement.projection,
        animationState = _this$visualElement.animationState;
      if (projection) {
        projection.isAnimationBlocked = false;
      }
      this.panSession && this.panSession.end();
      this.panSession = undefined;
      var _this$getProps6 = this.getProps(),
        dragPropagation = _this$getProps6.dragPropagation;
      if (!dragPropagation && this.openGlobalLock) {
        this.openGlobalLock();
        this.openGlobalLock = null;
      }
      animationState && animationState.setActive("whileDrag", false);
    }
  }, {
    key: "updateAxis",
    value: function updateAxis(axis, _point, offset) {
      var _this$getProps7 = this.getProps(),
        drag = _this$getProps7.drag;
      // If we're not dragging this axis, do an early return.
      if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
      var axisValue = this.getAxisMotionValue(axis);
      var next = this.originPoint[axis] + offset[axis];
      // Apply constraints
      if (this.constraints && this.constraints[axis]) {
        next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
      }
      axisValue.set(next);
    }
  }, {
    key: "resolveConstraints",
    value: function resolveConstraints() {
      var _this2 = this;
      var _a;
      var _this$getProps8 = this.getProps(),
        dragConstraints = _this$getProps8.dragConstraints,
        dragElastic = _this$getProps8.dragElastic;
      var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
      var prevConstraints = this.constraints;
      if (dragConstraints && isRefObject(dragConstraints)) {
        if (!this.constraints) {
          this.constraints = this.resolveRefConstraints();
        }
      } else {
        if (dragConstraints && layout) {
          this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
        } else {
          this.constraints = false;
        }
      }
      this.elastic = resolveDragElastic(dragElastic);
      /**
       * If we're outputting to external MotionValues, we want to rebase the measured constraints
       * from viewport-relative to component-relative.
       */
      if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
        eachAxis(function (axis) {
          if (_this2.constraints !== false && _this2.getAxisMotionValue(axis)) {
            _this2.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], _this2.constraints[axis]);
          }
        });
      }
    }
  }, {
    key: "resolveRefConstraints",
    value: function resolveRefConstraints() {
      var _this$getProps9 = this.getProps(),
        constraints = _this$getProps9.dragConstraints,
        onMeasureDragConstraints = _this$getProps9.onMeasureDragConstraints;
      if (!constraints || !isRefObject(constraints)) return false;
      var constraintsElement = constraints.current;
      invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var projection = this.visualElement.projection;
      // TODO
      if (!projection || !projection.layout) return false;
      var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
      var measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
      /**
       * If there's an onMeasureDragConstraints listener we call it and
       * if different constraints are returned, set constraints to that
       */
      if (onMeasureDragConstraints) {
        var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
        this.hasMutatedConstraints = !!userConstraints;
        if (userConstraints) {
          measuredConstraints = convertBoundingBoxToBox(userConstraints);
        }
      }
      return measuredConstraints;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation(velocity) {
      var _this3 = this;
      var _this$getProps10 = this.getProps(),
        drag = _this$getProps10.drag,
        dragMomentum = _this$getProps10.dragMomentum,
        dragElastic = _this$getProps10.dragElastic,
        dragTransition = _this$getProps10.dragTransition,
        dragSnapToOrigin = _this$getProps10.dragSnapToOrigin,
        onDragTransitionEnd = _this$getProps10.onDragTransitionEnd;
      var constraints = this.constraints || {};
      var momentumAnimations = eachAxis(function (axis) {
        if (!shouldDrag(axis, drag, _this3.currentDirection)) {
          return;
        }
        var transition = constraints && constraints[axis] || {};
        if (dragSnapToOrigin) transition = {
          min: 0,
          max: 0
        };
        /**
         * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
         * of spring animations so we should look into adding a disable spring option to `inertia`.
         * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
         * using the value of `dragElastic`.
         */
        var bounceStiffness = dragElastic ? 200 : 1000000;
        var bounceDamping = dragElastic ? 40 : 10000000;
        var inertia = _objectSpread(_objectSpread({
          type: "inertia",
          velocity: dragMomentum ? velocity[axis] : 0,
          bounceStiffness: bounceStiffness,
          bounceDamping: bounceDamping,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, dragTransition), transition);
        // If we're not animating on an externally-provided `MotionValue` we can use the
        // component's animation controls which will handle interactions with whileHover (etc),
        // otherwise we just have to animate the `MotionValue` itself.
        return _this3.startAxisValueAnimation(axis, inertia);
      });
      // Run all animations and then resolve the new drag constraints.
      return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
  }, {
    key: "startAxisValueAnimation",
    value: function startAxisValueAnimation(axis, transition) {
      var axisValue = this.getAxisMotionValue(axis);
      return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement, false, addValueToWillChange(this.visualElement, axis)));
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      var _this4 = this;
      eachAxis(function (axis) {
        return _this4.getAxisMotionValue(axis).stop();
      });
    }
  }, {
    key: "pauseAnimation",
    value: function pauseAnimation() {
      var _this5 = this;
      eachAxis(function (axis) {
        var _a;
        return (_a = _this5.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
      });
    }
  }, {
    key: "getAnimationState",
    value: function getAnimationState(axis) {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
  }, {
    key: "getAxisMotionValue",
    value: function getAxisMotionValue(axis) {
      var dragKey = "_drag".concat(axis.toUpperCase());
      var props = this.visualElement.getProps();
      var externalMotionValue = props[dragKey];
      return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
  }, {
    key: "snapToCursor",
    value: function snapToCursor(point) {
      var _this6 = this;
      eachAxis(function (axis) {
        var _this6$getProps = _this6.getProps(),
          drag = _this6$getProps.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, _this6.currentDirection)) return;
        var projection = _this6.visualElement.projection;
        var axisValue = _this6.getAxisMotionValue(axis);
        if (projection && projection.layout) {
          var _projection$layout$la = projection.layout.layoutBox[axis],
            min = _projection$layout$la.min,
            max = _projection$layout$la.max;
          axisValue.set(point[axis] - mixNumber(min, max, 0.5));
        }
      });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
  }, {
    key: "scalePositionWithinConstraints",
    value: function scalePositionWithinConstraints() {
      var _this7 = this;
      if (!this.visualElement.current) return;
      var _this$getProps11 = this.getProps(),
        drag = _this$getProps11.drag,
        dragConstraints = _this$getProps11.dragConstraints;
      var projection = this.visualElement.projection;
      if (!isRefObject(dragConstraints) || !projection || !this.constraints) return;
      /**
       * Stop current animations as there can be visual glitching if we try to do
       * this mid-animation
       */
      this.stopAnimation();
      /**
       * Record the relative position of the dragged element relative to the
       * constraints box and save as a progress value.
       */
      var boxProgress = {
        x: 0,
        y: 0
      };
      eachAxis(function (axis) {
        var axisValue = _this7.getAxisMotionValue(axis);
        if (axisValue && _this7.constraints !== false) {
          var latest = axisValue.get();
          boxProgress[axis] = calcOrigin({
            min: latest,
            max: latest
          }, _this7.constraints[axis]);
        }
      });
      /**
       * Update the layout of this element and resolve the latest drag constraints
       */
      var _this$visualElement$g = this.visualElement.getProps(),
        transformTemplate = _this$visualElement$g.transformTemplate;
      this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
      this.resolveConstraints();
      /**
       * For each axis, calculate the current progress of the layout axis
       * within the new constraints.
       */
      eachAxis(function (axis) {
        if (!shouldDrag(axis, drag, null)) return;
        /**
         * Calculate a new transform based on the previous box progress
         */
        var axisValue = _this7.getAxisMotionValue(axis);
        var _this7$constraints$ax = _this7.constraints[axis],
          min = _this7$constraints$ax.min,
          max = _this7$constraints$ax.max;
        axisValue.set(mixNumber(min, max, boxProgress[axis]));
      });
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this8 = this;
      if (!this.visualElement.current) return;
      elementDragControls.set(this.visualElement, this);
      var element = this.visualElement.current;
      /**
       * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
       */
      var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
        var _this8$getProps = _this8.getProps(),
          drag = _this8$getProps.drag,
          _this8$getProps$dragL = _this8$getProps.dragListener,
          dragListener = _this8$getProps$dragL === void 0 ? true : _this8$getProps$dragL;
        drag && dragListener && _this8.start(event);
      });
      var measureDragConstraints = function measureDragConstraints() {
        var _this8$getProps2 = _this8.getProps(),
          dragConstraints = _this8$getProps2.dragConstraints;
        if (isRefObject(dragConstraints) && dragConstraints.current) {
          _this8.constraints = _this8.resolveRefConstraints();
        }
      };
      var projection = this.visualElement.projection;
      var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
      if (projection && !projection.layout) {
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
      }
      frame.read(measureDragConstraints);
      /**
       * Attach a window resize listener to scale the draggable target within its defined
       * constraints as the window resizes.
       */
      var stopResizeListener = addDomEvent(window, "resize", function () {
        return _this8.scalePositionWithinConstraints();
      });
      /**
       * If the element's layout changes, calculate the delta and apply that to
       * the drag gesture's origin point.
       */
      var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function (_ref2) {
        var delta = _ref2.delta,
          hasLayoutChanged = _ref2.hasLayoutChanged;
        if (_this8.isDragging && hasLayoutChanged) {
          eachAxis(function (axis) {
            var motionValue = _this8.getAxisMotionValue(axis);
            if (!motionValue) return;
            _this8.originPoint[axis] += delta[axis].translate;
            motionValue.set(motionValue.get() + delta[axis].translate);
          });
          _this8.visualElement.render();
        }
      });
      return function () {
        stopResizeListener();
        stopPointerListener();
        stopMeasureLayoutListener();
        stopLayoutUpdateListener && stopLayoutUpdateListener();
      };
    }
  }, {
    key: "getProps",
    value: function getProps() {
      var props = this.visualElement.getProps();
      var _props$drag = props.drag,
        drag = _props$drag === void 0 ? false : _props$drag,
        _props$dragDirectionL = props.dragDirectionLock,
        dragDirectionLock = _props$dragDirectionL === void 0 ? false : _props$dragDirectionL,
        _props$dragPropagatio = props.dragPropagation,
        dragPropagation = _props$dragPropagatio === void 0 ? false : _props$dragPropagatio,
        _props$dragConstraint = props.dragConstraints,
        dragConstraints = _props$dragConstraint === void 0 ? false : _props$dragConstraint,
        _props$dragElastic = props.dragElastic,
        dragElastic = _props$dragElastic === void 0 ? defaultElastic : _props$dragElastic,
        _props$dragMomentum = props.dragMomentum,
        dragMomentum = _props$dragMomentum === void 0 ? true : _props$dragMomentum;
      return _objectSpread(_objectSpread({}, props), {}, {
        drag: drag,
        dragDirectionLock: dragDirectionLock,
        dragPropagation: dragPropagation,
        dragConstraints: dragConstraints,
        dragElastic: dragElastic,
        dragMomentum: dragMomentum
      });
    }
  }]);
}();
function shouldDrag(direction, drag, currentDirection) {
  return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset) {
  var lockThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
export { VisualElementDragControls, elementDragControls };